<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
  }>(),
  {
    viewBox: '0 0 42 42',
    height: 42,
    width: 42,
  },
);

const originalWidth = 42;
const originalHeight = 42;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg :width="computedWidth" :height="computedHeight" :viewBox="props.viewBox" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21" cy="21" r="20.625" fill="#B80909" stroke="#E0E0E0" stroke-width="0.75" />
    <path
      d="M20.2843 12.6251L20.2843 12.6251L20.2857 12.6226C20.3319 12.5417 20.4106 12.5 20.5006 12.5C20.588 12.5 20.6673 12.5399 20.717 12.6254C20.7171 12.6255 20.7171 12.6256 20.7172 12.6257L30.4663 29.4992C30.4664 29.4993 30.4665 29.4995 30.4666 29.4996C30.5632 29.6685 30.4416 29.875 30.2506 29.875H10.7506C10.5596 29.875 10.438 29.6686 10.5346 29.4997C10.5347 29.4995 10.5348 29.4993 10.5349 29.4992L20.2843 12.6251ZM12.1036 28.346L11.6702 29.0961H12.5365H28.4646H29.3309L28.8976 28.346L20.9335 14.56L20.5006 13.8106L20.0676 14.56L12.1036 28.346ZM20.0586 26.5044C19.9414 26.3872 19.8756 26.2283 19.8756 26.0625C19.8756 25.8967 19.9414 25.7378 20.0586 25.6206C20.1759 25.5033 20.3348 25.4375 20.5006 25.4375C20.6663 25.4375 20.8253 25.5033 20.9425 25.6206C21.0597 25.7378 21.1256 25.8967 21.1256 26.0625C21.1256 26.2283 21.0597 26.3872 20.9425 26.5044C20.8253 26.6217 20.6663 26.6875 20.5006 26.6875C20.3348 26.6875 20.1759 26.6217 20.0586 26.5044ZM20.7506 22.9375H20.2506V19.25H20.7506V22.9375Z"
      fill="#A3A3A3"
      stroke="white"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
